import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { ActivatedRoute, Params, ParamMap } from '@angular/router';
import { CommunicationsHttpService } from '../../../../services/communications/communications.http.service';
import { CommunicationsHttpUtil } from '../communications.util';
import { StorageUtil } from '../../../../utils/storage.util';
import { CommunicationsStateService } from '../communications.state.service';
import { AuthUtil } from '../../../../utils/auth.utils';
import { Observable, Subject } from 'rxjs';

@Component({
  moduleId: module.id,
  templateUrl: 'close.communications.component.html',
  selector: 'bft-close-communications',
  providers: []
})

export class CloseCommunicationsComponent implements OnInit, OnDestroy {

  searchTextSubscription: Subject<string> = new Subject();
  private _searchText: string;
  @Input() set searchText(value) {
    this.searchTextSubscription.next(value);
  }

  model: any = {};
  errorMessage: string;

  activeModel = [];

  reloadDataSubscription: any;

  constructor(
    private communicationsHttpService: CommunicationsHttpService,
    private communicationsStateService: CommunicationsStateService,
    private authUtil: AuthUtil) {
      this.followFilteredQuest();
  }

  ngOnInit() {
    this.getCloseQuest();

    this.reloadDataSubscription = this.communicationsStateService.handleReloadData().subscribe(data => {
      this.getCloseQuest();
    });
  }

  openQuest(number, theme, chatType) {
    this.communicationsStateService.triggerSingleQuest({number: number, questType: 'close', theme: theme, chatType: chatType});
  }

  setActiveModel(item) {
    this.activeModel = item;
  }

  getCloseQuest(searchText?) {
    const requestParams = this.getQuestParams(0, searchText);
    this.communicationsHttpService.getChats(requestParams).subscribe(
      success => {
        this.callbackSuccessGetGuest(success);
      },
      error => {
      },
      () => {
      });
  }

  // TODO duplicated in open communications
  getFilteredQuest(searchText): Observable<any> {
    const requestParams = this.getQuestParams(0, searchText);
    return this.communicationsHttpService.getChats(requestParams);
  }

  // TODO duplicated in open communications
  private followFilteredQuest(): void {
    this.searchTextSubscription
      .debounceTime(500)
      .switchMap(text => this.getFilteredQuest(text))
      .subscribe(success => {
        this.callbackSuccessGetGuest(success);
      });
  }

  // TODO duplicated in open communications
  private getQuestParams(active, searchText?): URLSearchParams {
    return CommunicationsHttpUtil.prepareParamsGetChats({
      securityToken: StorageUtil.getToken(),
      active: active,
      filter: searchText || ''
    });
  }

  // TODO duplicated in open communications
  private callbackSuccessGetGuest(success) {
    if (success) {
      let data = success.json();

      if (this.authUtil.isError(data)) {
        this.errorMessage = this.authUtil.errorMessage(data);

        this.authUtil.checkErrorResponse(data);
      } else {
        this.model = data.response && data.response.items || [];
        this.model = this.model.reverse();
      }
    }
  }

  ngOnDestroy() {
    this.reloadDataSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/communications/close-communications/close.communications.component.ts